import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const useBulkUpdatePricingPlanStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (params: Parameters<typeof apiClient.bulkUpdatePricingPlanStatus>[0]) =>
      await apiClient.bulkUpdatePricingPlanStatus(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ["pricing_plans"],
      });
      void queryClient.invalidateQueries({
        queryKey: [{ entity: "pricing_plans" }],
      });
      void queryClient.invalidateQueries({
        queryKey: ["plan_report"],
      });
      void queryClient.invalidateQueries({
        queryKey: ["planData"],
      });
    },
  });
};
